import RpcNonReportTypes from "./rpcNonReport.types";

export const listRpcNonReportStart = (RpcNonResponseList: any) => ({
  type: RpcNonReportTypes.RPC_NON_REPORT_LIST_START,
  payload: RpcNonResponseList,
});

export const listRpcNonReportSuccess = (success: any) => ({
  type: RpcNonReportTypes.RPC_NON_REPORT_LIST_SUCCESS,
  payload: success,
});

export const listRpcNonReportFailure = (failure: any) => ({
  type: RpcNonReportTypes.RPC_NON_REPORT_LIST_FAILURE,
  payload: failure,
});

export const listRpcNonReportResetStart = () => ({
  type: RpcNonReportTypes.RPC_NON_REPORT_LIST_RESET_START,
});

export const listRpcNonReportChanged = () => ({
  type: RpcNonReportTypes.RPC_NON_REPORT_LIST_CHANGED,
});

/******************CAMPAIGN START************** */

export const listRpcNonReportCampaignStart = (RpcNonResponseList: any) => ({
  type: RpcNonReportTypes.RPC_NON_REPORT_CAMPAIGN_START,
  payload: RpcNonResponseList,
});

export const listRpcNonReportCampaignSuccess = (success: any) => ({
  type: RpcNonReportTypes.RPC_NON_REPORT_CAMPAIGN_SUCCESS,
  payload: success,
});

export const listRpcNonReportCampaignFailure = (failure: any) => ({
  type: RpcNonReportTypes.RPC_NON_REPORT_CAMPAIGN_FAILURE,
  payload: failure,
});

export const listRpcNonReportCampaignResetStart = () => ({
  type: RpcNonReportTypes.RPC_NON_REPORT_CAMPAIGN_RESET_START,
});

export const listRpcNonReportCampaignChanged = () => ({
  type: RpcNonReportTypes.RPC_NON_REPORT_CAMPAIGN_CHANGED,
});
/******************CAMPAIGN END************** */

/******************EXPORT START************** */

export const listRpcNonReportExportStart = (RpcNonResponseList: any) => ({
  type: RpcNonReportTypes.RPC_NON_REPORT_EXPORT_START,
  payload: RpcNonResponseList,
});

export const listRpcNonReportExportSuccess = (success: any) => ({
  type: RpcNonReportTypes.RPC_NON_REPORT_EXPORT_SUCCESS,
  payload: success,
});

export const listRpcNonReportExportFailure = (failure: any) => ({
  type: RpcNonReportTypes.RPC_NON_REPORT_EXPORT_FAILURE,
  payload: failure,
});

export const listRpcNonReportExportResetStart = () => ({
  type: RpcNonReportTypes.RPC_NON_REPORT_EXPORT_RESET_START,
});

export const listRpcNonReportExportChanged = () => ({
  type: RpcNonReportTypes.RPC_NON_REPORT_EXPORT_CHANGED,
});
/******************EXPORT END************** */
